import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { Save as SaveIcon, Cancel as CancelIcon } from "@material-ui/icons";
import { TextValidator, ValidatorForm, SelectValidator } from "react-material-ui-form-validator";
import { Modal } from "src/components";
import { atualizar, cadastrar } from "src/store/actions/categorias_produtos";

function ModalProdutos({ type, open, close, produto }) {
  const [formProduto, setFormProduto] = useState(produto);

  useEffect(() => {
    if (!produto) {
      setFormProduto({ titulo: "", ordem: 0 });
    } else {
      setFormProduto(produto);
    }
  }, [produto]);

  const handleChange = (event) => {
    setFormProduto({ ...formProduto, [event.target.name]: event.target.value });
  };

  const handleSubmit = async () => {
    if (type === "insert") {
      await cadastrar(formProduto);
    } else {
      await atualizar(formProduto);
    }

    setFormProduto({ titulo: "", ordem: 0 });
    close();
  };

  return (
    <Modal open={open} width={450} heigth={100}>
      <Box display="flex" flexDirection="column" gap="8px">
        <Typography>
          {type === "update" ? "Atualizar categoria" : "Cadastrar categoria"}
        </Typography>
        <ValidatorForm onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column'}}>
          <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
            <TextValidator
              label="Título"
              name="titulo"
              onChange={handleChange}
              value={formProduto.titulo}
              validators={["required"]}
              errorMessages={["Campo obrigatório"]}
              margin="dense"
              style={{margin: 2, width: 300}}
            />
            <TextValidator
              label="Ordem"
              name="ordem"
              onChange={handleChange}
              value={formProduto.ordem}
              validators={['minNumber:0', 'maxNumber:255', 'matchRegexp:^[0-9]$']}
              errorMessages={["Deve ser maior ou igual a 0.", "Deve ser menor que 255", "deve ser um número."]}
              margin="dense"
              style={{margin: 2}}
            />
          </div>
          <Box display="flex" justifyContent="flex-end" style={{width: '100%'}}>
            <Button type="submit" color="primary" size="small">
              {<SaveIcon />}&nbsp;Gravar
            </Button>
            <Button color="secondary" size="small" onClick={close}>
              {<CancelIcon />}&nbsp;Cancelar
            </Button>
          </Box>
        </ValidatorForm>
      </Box>
    </Modal>
  );
}

export default ModalProdutos;
